import React from "react";
import { LucideBookOpen } from "lucide-react";
import SelectCourseCard from "./SelectCourseCard";
import HeaderComponent from "components/card/HeaderComponent";

export default function ChooseCourseBoard({
  courses,
  selectedCourse,
  setSelectedCourse,
}) {

  return (
    <div className="col-span-2">
      <HeaderComponent
        title="Step 1: Choose Your Course"
        titleClass="text-lg dark:text-white"
        description="Browse and select from our curated training programs"
        bgcolor="bg-gradient-to-br from-purple-50 to-indigo-50 dark:from-purple-800 dark:to-white/10"
        icon={<LucideBookOpen className="text-white" size={20}/>}
        colorTheme="gradient-purple"
      >
        <div className="pt-10">
          <div className="relative h-[500px] overflow-y-auto pr-2">
            <div className="space-y-4">
              {courses?.map((course, index) => (
                <SelectCourseCard
                  key={course.title}   
                  {...course}
                  index={index}
                  selected={selectedCourse?.title === course.title}
                  onClick={() => setSelectedCourse(course)}
                />
              ))}
            </div>
          </div>
        </div>
      </HeaderComponent>
    </div>
  );
};
